export default "__VITE_ASSET__LET3Om4f__"